export { default } from './color';
